import cs from "classnames";
import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { getNavLabelKey } from "_i18n/navLabels";

const grouplinksPermissionsHelper = [
  { label: "Zajęcia", Id: 131, permission: false },
  { label: "Drafty", Id: 295, disabled: false },
  { label: "Cykliczne", Id: 173, disabled: false },
  { label: "Radar", Id: 282, permission: false },
  { label: "Dostępni trenerzy", Id: 283, permission: false },
  { label: "Zgłoszenia", Id: 262, permission: false },
  { label: "Kandydaci", Id: 264, permission: false },
  { label: "Zamówienia", Id: 160, disabeld: false },
  { label: "Składki", Id: 161, disabled: false },
  { label: "Kupony", Id: 373, disabled: false },
  { label: "Produkty", Id: 162, disabled: false },
  { label: "Kategorie", Id: 163, disabled: false },
  { label: "Atrybuty", Id: 164, disabled: false },
  { label: "Dostawy", Id: 165, disabled: false },
];

const NavbarItem: React.FC<any> = ({
  icon: Icon,
  label,
  items,
  path,
  isExpanded,
  onExpand,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const permission = useSelector((state: any) => state.permissions.permissions);
  const trainerPlayerRouterDetail = useSelector(
    (state: any) => state.radarRouteDetailReducer,
  );

  const navItemsWithPermissions = items?.map((item: any) => {
    const matchedPermission = grouplinksPermissionsHelper.find(
      (helperItem) => helperItem.label === item.label,
    );
    return {
      ...item,
      disabled: matchedPermission
        ? !permission.some((perm: any) => perm.Id === matchedPermission.Id)
        : true,
    };
  });

  const navbarShopTabs =
    permission[0]?.Id === -1 ? items : navItemsWithPermissions;

  const isTrainerInvitationDetail = location.pathname.includes(
    "/outside-trainers/detail",
  );
  const isPlayerInvitationDetail = location.pathname.includes(
    "/outside-players/detail",
  );
  const isTrainersDetail = location.pathname.includes("/trainers/detail");
  const isPlayersDetail = location.pathname.includes("/players/detail");

  const isTrainerFromRadar =
    trainerPlayerRouterDetail?.isActive &&
    trainerPlayerRouterDetail?.routeDetailName?.includes("/trainers/detail");

  const isPlayerFromRadar =
    trainerPlayerRouterDetail?.isActive &&
    trainerPlayerRouterDetail?.routeDetailName?.includes("/players/detail");

  const isRadarTrainersActive =
    label === "Rekrutacja trenerĂłw" &&
    (isTrainerInvitationDetail ||
      isTrainerFromRadar ||
      location.pathname === "/outside-trainers/requested" ||
      location.pathname === "/outside-trainers/available");

  const isRadarPlayersActive =
    label === "NabĂłr" &&
    (isPlayerInvitationDetail ||
      isPlayerFromRadar ||
      location.pathname === "/outside-players/requested" ||
      location.pathname === "/outside-players/available");

  const cleanPath = (p: string | undefined) =>
    p ? p.split("?")[0].split("#")[0] : "";

  const allCleanPaths = [
    ...(items?.map((item: any) => cleanPath(item.path)) ?? []),
    cleanPath(path),
  ].filter(Boolean);

  const isBasePathMatch = allCleanPaths.some((basePath: string) => {
    if (
      basePath === "/trainers" &&
      label === "Trenerzy" &&
      isTrainersDetail &&
      isTrainerFromRadar
    ) {
      return false;
    }
    if (
      basePath === "/players" &&
      label === "Zawodnicy" &&
      isPlayersDetail &&
      isPlayerFromRadar
    ) {
      return false;
    }

    return (
      location.pathname === basePath ||
      location.pathname.startsWith(basePath + "/")
    );
  });

  let finalIsActive = false;
  if (isRadarTrainersActive || isRadarPlayersActive) {
    finalIsActive = isRadarTrainersActive || isRadarPlayersActive;
  } else {
    finalIsActive = isBasePathMatch;
  }

  const listClasses = cs("overflow-hidden", {
    "h-0": !isExpanded,
    "-mt-1 mb-2 ml-2": items?.length && isExpanded,
  });

  const isEventsRoute = location?.pathname.includes("events");
  const isStructureRoute = location?.pathname.includes("/structure");
  const getEventsView = localStorage.getItem("isEventView");
  const getStructureEventsView = localStorage.getItem("isEventGroupView");

  if (!isEventsRoute && getEventsView === "false") {
    localStorage.setItem("isEventView", "true");
  }

  if (!isStructureRoute && getStructureEventsView === "false") {
    localStorage.setItem("isEventGroupView", "true");
  }

  return (
    <div>
      {path ? (
        <NavLink
          className="navItem subItems"
          to={path}
          exact={path === "/"}
          onClick={onExpand}
          style={{
            color: finalIsActive ? "#FF9200" : "#9CB0C4",
            letterSpacing: "-0.5px",
            padding: "4px 18px",
            background: finalIsActive ? "black" : "",
            border: finalIsActive ? "1px solid rgba(156, 176, 196, 0.3)" : "",
            borderRadius: finalIsActive ? "8px" : "0px",
          }}
        >
          <Icon
            style={{
              color: finalIsActive ? "#FF9200" : "9CB0C4",
              hight: "15px",
              width: "15px",
            }}
          />
          <span>{t(getNavLabelKey(label))}</span>
        </NavLink>
      ) : (
        <NavLink
          className={`navItem ${finalIsActive ? "active" : "subItems"}`}
          to={items[0]?.path}
          onClick={onExpand}
          style={{
            color: finalIsActive ? "#FF9200" : "#9CB0C4",
            border: finalIsActive ? "1px solid rgba(156, 176, 196, 0.3)" : "",
            letterSpacing: "-0.5px",
            padding: "4px 18px",
            background: finalIsActive ? "black" : "",
            borderRadius: finalIsActive ? "6px" : "0px",
            cursor: "pointer",
          }}
        >
          <Icon style={{ color: finalIsActive ? "#FF9200" : "#9CB0C4" }} />
          <span>{t(getNavLabelKey(label))}</span>
        </NavLink>
      )}

      <div
        className={listClasses}
        style={{ overflow: "auto", marginTop: "2px" }}
      >
        {navbarShopTabs?.map(
          ({ disabled, label: subLabel, path, idx }: any) => {
            const isTrainerRequested =
              location.pathname === "/outside-trainers/requested";
            const isTrainerAvailable =
              location.pathname === "/outside-trainers/available";
            const isPlayerRequested =
              location.pathname === "/outside-players/requested";
            const isPlayerAvailable =
              location.pathname === "/outside-players/available";

            const cleanedSubPath = cleanPath(path);

            const isSubPathActive =
              location.pathname === cleanedSubPath ||
              location.pathname.startsWith(cleanedSubPath + "/");

            const isSpecificRadarSubItemActive =
              (isTrainerRequested && subLabel === "Kandydaci") ||
              (isTrainerAvailable && subLabel === "Dostępni trenerzy") ||
              (isPlayerRequested && subLabel === "Zgłoszenia") ||
              (isPlayerAvailable && subLabel === "Radar") ||
              (isTrainerInvitationDetail && subLabel === "Kandydaci") ||
              (isTrainerFromRadar && subLabel === "Dostępni trenerzy") ||
              (isPlayerInvitationDetail && subLabel === "Zgłoszenia") ||
              (isPlayerFromRadar && subLabel === "Radar");

            const isPaddingApplied =
              subLabel === "Zajęcia" ||
              subLabel === "Radar" ||
              subLabel === "Dostępni trenerzy" ||
              subLabel === "Zamówienia";

            return (
              <div
                onClick={() => {
                  if (disabled) {
                    toast.error(t("common.noPermission"));
                  }
                }}
                key={subLabel}
              >
                <div
                  style={{
                    pointerEvents: !disabled ? "auto" : "none",
                    opacity: disabled ? "0.4" : "",
                  }}
                  className={isSubPathActive ? "" : "subItems"}
                >
                  <NavLink
                    exact={path === "/home"}
                    to={path}
                    className="navItem text-xs py-2 "
                    style={{
                      color:
                        isSubPathActive || isSpecificRadarSubItemActive
                          ? "#FF9200"
                          : "#9cb0c4",
                      letterSpacing: "-0.5px",
                      background: isSubPathActive ? "black" : "",
                      border: isSubPathActive
                        ? "1px solid rgba(156, 176, 196, 0.3)"
                        : "",
                      borderRadius: isSubPathActive ? "6px" : "0px",
                      margin: "2px 0 0 0",
                      lineHeight: "16px",
                      cursor: "pointer",
                    }}
                  >
                    <span
                      style={{
                        width: "160px",
                        paddingLeft: "25px",
                        paddingTop: "2px",
                        color:
                          isSubPathActive || isSpecificRadarSubItemActive
                            ? "#FF9200"
                            : "#9cb0c4",
                        padding: "2px 24px",
                      }}
                    >
                      {t(getNavLabelKey(subLabel))}
                    </span>
                  </NavLink>
                </div>
              </div>
            );
          },
        )}
      </div>
    </div>
  );
};

export default NavbarItem;
